// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome {
  display: flex;
  height: 100dvh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.welcome h2 {
  color: #383838;
  font-weight: 700;
  font-size: 16px;
  line-height: 110%;
  padding-bottom: 15px;
}
.welcome h4 {
  color: #231F20;
  font-weight: 700;
  font-size: 36px;
  line-height: 100%;
  padding-bottom: 80px;
}

.eintracht {
  background: #282828;
  height: 100dvh;
}
.eintracht .welcome h2, .eintracht .welcome h4 {
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/welcome-login-sso-modal/welcome-login-sso-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACG,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AACJ;AAAC;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAEF;AAAC;EACC,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AAEF;;AACA;EACC,mBAAA;EACA,cAAA;AAED;AAAE;EACC,WAAA;AAEH","sourcesContent":[".welcome {\n\tdisplay: flex;\n    height: 100dvh;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n\th2 {\n\t\tcolor:#383838;\n\t\tfont-weight: 700;\n\t\tfont-size: 16px;\n\t\tline-height: 110%;\n\t\tpadding-bottom: 15px;\n\t}\n\th4 {\n\t\tcolor: #231F20;\n\t\tfont-weight: 700;\n\t\tfont-size: 36px;\n\t\tline-height: 100%;\n\t\tpadding-bottom: 80px;\n\t}\n}\n.eintracht {\n\tbackground: #282828;\n\theight: 100dvh;\n\t.welcome {\n\t\th2, h4 {\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
